import { ErrorLayout, ErrorLayoutProps } from 'components';
import { useTranslation } from 'libs/i18n';

interface Props extends Partial<ErrorLayoutProps> {}

export const ErrorFallback = (props: Props) => {
  const { t } = useTranslation();

  const handleClick = () => {
    window.location.reload();
  };

  return (
    <ErrorLayout
      buttonLabel={t('errorFallback.buttonLabel')}
      onButtonClick={handleClick}
      {...props}
    />
  );
};
